import React from 'react';
import './Explore.css';
import BottomNavbar from '../BottomNavbar/BottomNavbar';

const Explore = () => {
  return (
    <div className="explore-container">
      <h2>Explore Page</h2>
      <p>This is where users can explore other profiles.</p>


      <BottomNavbar />
    </div>
  );
};

export default Explore;
